import axios from "@/plugins/axios";

import employees from "./employees";
import employers from "./employers";
import inquiries from "./inquiries";
import matchings from "./matchings";

let url = "/api/v1/expo/programs";

export const programs = {
    employees,
    employers,
    inquiries,
    matchings,

    gets(data) {
        return axios.get(url, data).then((result) => result.data);
    },
    get(data) {
        return axios.get(`${url}/${data._id}`).then((result) => result.data);
    },
    getRanks(data) {
        return axios.get(`${url}/${data._id}/ranks`, data).then((result) => result.data);
    },
    getStatistic(data) {
        return axios.get(`${url}/${data._id}/statistic`).then((result) => result.data);
    },
};

export default programs;
